import { render } from "./trending-course.vue?vue&type=template&id=ac51a98a"
import script from "./trending-course.vue?vue&type=script&lang=js"
export * from "./trending-course.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__